<!-- Иконка направления выбранного периода календаря. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 12H19M13 6L19 12L13 18" :stroke="stroke" stroke-width="2" />
  </svg>
</template>

<script>
export default {
  name: "CalendarRangeArrowIcon",

  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
